

(function contentDirectiveDefinition() {

    angular.module('ui.Layout')
           .directive('content', ['config', function contentDirectiveFactory(config) {

               return {
                   template: '<div class="app-content"><div class="main-content" ><div ui-view class="wrap-content container-fluid fade-in-up" id="container"></div></div></div>',
                   restrict: 'E',
                   link: function contentDirectiveLink($scope, $element, $attrs) {
                       
                   }
               };

           }]);

})();